// import React from "react";
// import { Modal, Box, Typography } from "@mui/material";
// import { useSelector } from "react-redux";

// const InfoPopUp = ({ open, onClose, title, description }) => {
//   const theme = localStorage.getItem("theme");
//   const { allColors } = useSelector((state) => state);

//   const contentStyle = {
//     // bgcolor: theme === "dark" ? "#273338" : "#fff",
//     bgcolor:
//       theme === "dark"
//         ? allColors.darkBackgroundColor
//         : allColors.lightBackgroundColor,
//     color: "var(--text-color)",
//     textAlign: "center",
//     mx: "auto",
//     my: "10vh",
//     width: { xs: "90%", sm: 500 },
//     borderRadius: 2,
//     boxShadow: "0 0 60px 30px #fff,0 0 100px 60px #f0f,0 0 140px 90px #0ff",
//     outline: "none",
//   };

//   const headerStyle = {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     borderBottom: "2px solid #616266",
//     padding: "16px",
//     position: "relative",
//     bgcolor:
//       theme === "dark"
//         ? allColors.popupHeaderColor
//         : allColors.lightPopupHeaderColor,
//   };

//   const bodyStyle = {
//     padding: "16px",
//     textAlign: "left",
//     bgcolor:
//       theme === "dark"
//         ? allColors.popupBodyColor
//         : allColors.lightPopupBodyColor,
//   };
//   return (
//     <Modal open={open} onClose={onClose}>
//       <Box sx={contentStyle}>
//         <div style={headerStyle}>
//           <Typography variant="h6">{title?.toUpperCase()}</Typography>
//           <button className="close-button" onClick={onClose}>
//             <span className="close-icon-wallet">&times;</span>
//           </button>
//           {/* <i
//             class="fa-solid fa-x"
//             style={{ cursor: "pointer" }}
//             onClick={onClose}
//           ></i> */}
//         </div>
//         <div style={bodyStyle}>
//           <Typography variant="body1">{description}</Typography>
//         </div>
//       </Box>
//     </Modal>
//   );
// };

// export default InfoPopUp;

import React from "react";
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const InfoPopUp = ({ open, onClose, title, description, width = "xs" }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={width}
      fullWidth
      PaperProps={{
        sx: {
          boxShadow:
            "0 0 60px 30px #fff, 0 0 100px 60px #f0f, 0 0 140px 90px #0ff",
          borderRadius: 3,
        },
      }}
    >
      {title && (
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 1,
          }}
        >
          <Typography variant="h6" sx={{ visibility: "hidden" }}>
            S
          </Typography>
          <Typography variant="h6">{title}</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
      )}
      <DialogContent
        sx={{
          mt: 2,
          overflow: "auto",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          scrollbarWidth: "none",
        }}
      >
        {description}
      </DialogContent>
    </Dialog>
  );
};

export default InfoPopUp;
